import { DeviceTypeIds } from '@ncss/models/dist/v3';
import { BLE_SERVICES, DirectConnectBaseDevice } from '../base/directConnectBaseDevice';
import { ByteList } from 'byte-list';

export class DirectConnectNR4 extends DirectConnectBaseDevice {
  static Init() {
    DirectConnectBaseDevice.RegisterType(DeviceTypeIds.NR4, DirectConnectNR4);
  }

  protected serviceId = BLE_SERVICES.WALK_BY.ID;
  protected notifyCharacteristicId = BLE_SERVICES.WALK_BY.CHARACTERISTICS.NOTIFY;
  protected writeCharacteristicId = BLE_SERVICES.WALK_BY.CHARACTERISTICS.WRITE;

  protected parseManufacturerData(bytes: ByteList): void {}

  protected registerMessages(): void {}
}
